module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/boxoffice-module/components/basket-info-bar/basket-info-bar.component.scss
// module id = ./src/app/modules/boxoffice-module/components/basket-info-bar/basket-info-bar.component.scss
// module chunks = 9